import { Page as CorePage } from '@localina/core';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IApplicationStore } from '../../interfaces';
import { RestaurantHeader } from '../RestaurantHeader';
import { StepBar } from '../StepBar';

interface IProps {
    name: string;
    isLoading?: boolean;
    step?: number;
    children?: React.ReactNode;
    restaurant?: IApplicationStore['restaurant']['configuration'];
}

export const Page: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const showTrademark = props.restaurant && !props.restaurant.widgetWhiteLabeled;

    useEffect(() => {
        if (props.restaurant?.widgetCssUrl) {
            const createStylesheet = (url: string) => {
                const link = document.createElement('link');
                link.href = url;
                link.rel = 'stylesheet';
                return link;
            };

            const stylesheet = createStylesheet(props.restaurant.widgetCssUrl);
            document.head.appendChild(stylesheet);

            return () => {
                document.head.removeChild(stylesheet);
            };
        }
    }, [props.restaurant?.widgetCssUrl]);

    return (
        <CorePage
            name={props.name}
            title={props.restaurant ? <RestaurantHeader restaurant={props.restaurant} /> : undefined}
            subtitle={props.step !== undefined ? <StepBar step={props.step} /> : undefined}
            isLoading={props.isLoading}
            footer={showTrademark && t('common.footer')}
        >
            <div className="widget-page__content">{props.children}</div>
        </CorePage>
    );
};
